import { render, staticRenderFns } from "./MemberTeamsTable.vue?vue&type=template&id=3486e496&scoped=true&lang=pug&"
import script from "./MemberTeamsTable.vue?vue&type=script&lang=js&"
export * from "./MemberTeamsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486e496",
  null
  
)

export default component.exports